import { memo, PropsWithChildren, useCallback } from 'react';
import { PopconfirmProps } from './popconfirm.types';
import { Text } from '../text';
import { Button } from '../button';
import { Popover } from '../popover';
import { HStack, VStack } from '../stack';
import { Icons } from 'assets';
import { SVG } from 'components/svg';
import { Description, StyledContent } from './popconfirm.styled';

export const Popconfirm = memo((props: PropsWithChildren<PopconfirmProps>) => {
  const {
    title,
    description,
    confirmText = 'Подтвердить',
    cancelText = 'Отмена',
    onConfirm,
    onCancel,
    open,
    onOpenChange,
    ...popoverProps
  } = props;

  const isTriggerMode = 'children' in props;

  const handleConfirm = useCallback(() => {
    onConfirm();
    onOpenChange?.(false);
  }, [onConfirm, onOpenChange]);

  const handleCancel = useCallback(() => {
    onCancel?.();
    onOpenChange?.(false);
  }, [onCancel, onOpenChange]);

  return (
    <Popover.Root open={open} onOpenChange={onOpenChange} modal>
      {isTriggerMode ? (
        <Popover.Trigger>{props.children}</Popover.Trigger>
      ) : (
        <Popover.Anchor virtualRef={props.anchorRef} />
      )}

      <StyledContent {...popoverProps}>
        <VStack padding={8} spacing="s" align="flex-start">
          <VStack spacing="xxs" align="flex-start">
            <HStack spacing="xs" align="center">
              <SVG
                src={Icons.CrossCircleFilled}
                props={{ color: '#FC8181', size: '16px' }}
              />
              <Text variant="heading-4">{title}</Text>
            </HStack>

            {description ? (
              <Description>
                <Text variant="body-14">{description}</Text>
              </Description>
            ) : null}
          </VStack>

          <HStack justify="flex-end" spacing="xs" width="100%">
            <Button
              mode="accent"
              variant="ghost"
              size="xs"
              onClick={handleCancel}
            >
              {cancelText}
            </Button>
            <Button
              mode="accent"
              variant="main"
              size="xs"
              onClick={handleConfirm}
            >
              {confirmText}
            </Button>
          </HStack>
        </VStack>
      </StyledContent>
    </Popover.Root>
  );
});
